export default "__VITE_ASSET__7KIivW7z__"